import {TeamPlanLeadFormEvent} from './team-plan-lead-form-event';

/**
 * Amplitude event fired once when the user first interacts with any
 * field in the Team Plan sign-up form (focus or change).
 */
export class TeamPlanLeadFormInteractedEvent extends TeamPlanLeadFormEvent {
    constructor(formId: string) {
        super('tp_lead_form_interacted', formId);
    }
}
